import { observer } from 'mobx-react';
import { SkeletonTileViewProgramExperience } from '../../../Native/AEP/Common/ProgramExperience';
import { lookupAndFilter } from '../../ExperiencesDictionary';
import { ExperienceDictionaryEntryResponse } from '../../ExperiencesDictionary/Types';
import experiencesStore, { isLoaded } from '../ExperiencesStore';
import useExperiencesStore from '../ExperiencesStore/UseExperiencesStore';
import { PortalExperienceProvider } from '../PortalExperience/PortalExperienceContextProvider';
import ExperienceTile from './ExperienceTiles/ExperienceTile';

function ExperienceTiles() {
  useExperiencesStore();

  if (!isLoaded(experiencesStore)) {
    return (
      <div className="mt-14 grid gap-4 px-6 sm:grid-cols-2 md:px-16 lg:grid-cols-3 xl:grid-cols-4">
        {Array.from({ length: 12 }, (_, index) => (
          <SkeletonTileViewProgramExperience key={index} />
        ))}
      </div>
    );
  }
  return (
    <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {experiencesStore.state.experiences.payload.experiences
        .reduce(lookupAndFilter, [] as ExperienceDictionaryEntryResponse[])
        .map((experience) => {
          return (
            <div
              key={experience.payload.id}
              className="box-border flex w-full sm:max-w-full xl:min-w-[17rem] xl:max-w-[26.625rem]"
            >
              <PortalExperienceProvider experience={experience} key={experience.payload.id}>
                <ExperienceTile />
              </PortalExperienceProvider>
            </div>
          );
        })}
    </div>
  );
}

export default observer(ExperienceTiles);
